export default function timeSetter(Authentication, Utils, dateFilter, sdk, $parse) {
  'ngInject';

  return {
    require: 'ngModel',
    link($scope, $element, $attrs, $ngModel) {
      const getter = $parse($attrs.timeSetter);
      const setter = $parse($attrs.timeSetter).assign;
      const onChange = $parse($attrs.timeSetterOnChange);
      const setToNextDay = 'setToNextDay' in $attrs;
      let minDate;

      if (setter) {
        $scope.$watch(
          () => $ngModel.$viewValue,
          (val) => {
            if (!$ngModel.$valid) {
              return;
            }

            if (val) {
              let date = getter($scope);
              if (!date && $attrs.timeSetterDefault) {
                date = $scope.$eval($attrs.timeSetterDefault);
              }

              if (!date) {
                date = new Date();
              }

              let newDate = new Date(dateFilter(date, 'yyyy/MM/dd ') + Utils.parseTimeString(val));
              if (setToNextDay && newDate < minDate) {
                newDate = Utils.addDays(newDate, 1);
              }

              setter($scope, newDate);
            } else {
              setter($scope, null);
            }

            $ngModel.$validate();
            onChange($scope);
          }
        );

        if ($attrs.timeSetterMinDate && !setToNextDay) {
          $ngModel.$validators['min-date'] = () => (minDate ? getter($scope) >= minDate : true);

          $scope.$watch($attrs.timeSetterMinDate, () => {
            minDate = $parse($attrs.timeSetterMinDate)($scope);
            $ngModel.$validate();
          });
        }
      }
    },
  };
}
